import styled from "styled-components";

export const CheckboxHiddenInput = styled.input`
  position: absolute;
  left: 0.625rem;
  opacity: 0;
  z-index: -1;
`;
export default CheckboxHiddenInput;
